  $(".header__menu .dropdown").hover(
        function () {
          $('.navbar').addClass("mega-menu-visible");
        },
        function () {
          $('.navbar').removeClass("mega-menu-visible");
        }
      );
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 50) {
        $("header").addClass("scrolled-up");
    } else {
        $("header").removeClass("scrolled-up");
    }
});

  $('.instagram-carousel').slick({
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });





     var styleBackup = '', restOfTimeout = 500, currentState = '', freeze = false;
      $('.top-bar_info').on('init', function(event, slick, direction){
        const observer = new MutationObserver(function(mutationsList, observer){
          for(const mutation of mutationsList) {
            if (mutation.type === 'attributes' &&  mutation.attributeName == 'style' && freeze) {
              $('.top-bar_info .slick-track').css('transform', currentState);
            }
          }
        });
        observer.observe($('.top-bar_info .slick-track')[0], { attributes: true });
        $('.top-bar_info .slick-track').mouseover(function() {
          styleBackup = $('.top-bar_info .slick-track').attr('style');
          currentState = getComputedStyle($('.top-bar_info .slick-track')[0]).transform;
          freeze = true;        
          $('.top-bar_info').slick('slickPause');       
          let translateDone = parseFloat(currentState.split(',')[4])*(-1);            
          let regex = /translate3d\(([^,]*),/gm;
          if((m = regex.exec(styleBackup)) !== null) {
            let translateNeed = parseFloat(m[1])*(-1);
            let slideWidth = $('.top-bar_info .slick-slide').first().width();
            let speed = 5000/slideWidth;
            restOfTimeout = (translateNeed-translateDone)*speed;   
            var report = "Should be: "+translateNeed+"\n";
            report += "Did on hover moment: "+translateDone+"\n";
            report += "Still has to scroll: "+(translateNeed-translateDone)+"px\n";
            report += "Speed of scroll: "+speed+"ms\n";
            report += "Desired timeout: "+restOfTimeout+"ms\n";
            $('#report').text(report);
          } else {
            restOfTimeout = 500;
          } 
          $('.top-bar_info .slick-track').css('transform', currentState);        
        });    
        $('.top-bar_info .slick-track').mouseout(function() {     
          freeze = false;
          $('.top-bar_info .slick-track').attr('style', styleBackup.replace('5000ms', restOfTimeout+'ms'));
          $('.top-bar_info').slick('slickPlay');
        });
      });

      $('.top-bar_info').slick({
        slidesToShow: 3,    
        speed: 10000,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        slidesToScroll: 1,    
        pauseOnHover: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              variableWidth: true
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });


    $('.product-grid__carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      variableWidth: false,
      infinite: false,
      arrows: true,

      responsive: [

    {
      breakpoint: 1199,
      settings: "unslick"
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
     
      });

// REMOVE THIS IF STILL NOT WORKING : START

      $(window).on('resize', function() {
        if (!$('.product-grid__carousel').hasClass('slick-initialized')) {
          $('.product-grid__carousel').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            variableWidth: false,
            infinite: false,
            arrows: true,
      
            responsive: [
      
          {
            breakpoint: 1199,
            settings: "unslick"
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
           
            });
        }
      });
// REMOVE THIS IF STILL NOT WORKING : END

    $('.image-carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      variableWidth: false,
      infinite: false,
      arrows: true,
      dots: false,
      autoplay: false,
      responsive: [
         {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              arrows: true,
              variableWidth: true,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              arrows: false,
              variableWidth: true,
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });



if ($('body.product-page').length>0) {
  $( window ).on("load", function() {
    var glider = new Glider(document.querySelector('.pswp-gallery'), {
      slidesToShow: 1,
      dots: '.dots',
      draggable: true
    });
  });
}

$(window).on('load', function() {
  $('.sustainability-content').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  autoplay: 5000,
  asNavFor: '.sustainability-nav'
  });
$('.sustainability-nav').slick({
  infinite: true,
  slidesToShow: 8,
  slidesToScroll: 1,
  asNavFor: '.sustainability-content',
  arrows: false,
  dots: false,
  centerMode: false,
  centerPadding: '10px',
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        centerMode: false,
      }
    }
  ]

});
  });



  



     $(".js-nav-link").hover(function () {
                    var positionLeftMenu = $(".js-header-menu").offset().left,
                        positionItemLeft = $(this).offset().left,
                        difference = positionItemLeft - positionLeftMenu,
                        width = $(this).outerWidth() + 0;
                    $(".js-header-nav-background-hover").css("left", difference).css("width", width);
                });
     var turnOffBackground = !1;

     $(".js-header-menu").hover(
                    function () {
                        setTimeout(function () {
                            $(".js-header-nav-background-hover").addClass("active");
                        }, 100),
                            clearTimeout(turnOffBackground);
                    },
                    function () {
                        turnOffBackground = setTimeout(function () {
                            $(".js-header-nav-background-hover").removeClass("active");
                        }, 1e3);
                    });




$(".dropdown-link .nav-link").click(function() {
  $(this).parent().toggleClass('selected').siblings().removeClass('selected');
});

$('.btn-close').click(function() {
  $('body').removeClass('offcanvas-open');
  $('.dropdown-link').removeClass('selected');
});

$('.close-box').click(function() {
  $('body').removeClass('offcanvas-open');
  $('.dropdown-link').removeClass('selected');
});

// Prepend back button to sub menu(s)
$('.nav__sub').prepend('<li class="nav-item"><a class="nav-link sub__close" href="#"> Back</a></li>');

  // Close out sub menu
  $('.sub__close').click(function(e) {
    e.preventDefault();
    
    $(this).parent().parent().removeClass('is-active');
  });

  // Trigger sub menu
  $('.have-sub-menu > .nav-link').click(function(e) {
    e.preventDefault();
    
    $(this).siblings().addClass('is-active');
    $('.offcanvas-start').addClass('bg-0');

     
  });

  $('.btn-wishlist').on("click", function() {
        $(this).toggleClass('added');
    });

    $('.open-form').click(function(e) {
    $('.addresses-form').toggleClass('hide'); 
  });


  // simple offcanvas  (Shop, Sustainability, Search, Navbar)
  $('[data-offcanvas="panel"]').on('show.bs.offcanvas', () => {
    $('body').addClass('offcanvas-visible');
    console.log('offcanvas-visible');
  })
  $('[data-offcanvas="panel"]').on('hide.bs.offcanvas', () => {
    $('body').removeClass('offcanvas-visible');
    //$('#offcanvasNavbar').removeClass('offcanvas-start').addClass('offcanvas-end')
    $('#offcanvasNavbar').find('.nav__sub').removeClass('is-active')
    //$('#offcanvasNavbar').removeClass('offcanvas-class').addClass('offcanvas-end')
  })
 
  /* 
    // NVBAR
    $('#offcanvasNavbar').on('show.bs.offcanvas', () => {
      $('body').addClass('offcanvas-visible');
    })
    $('#offcanvasNavbar').on('hide.bs.offcanvas', () => {
      $('body').removeClass('offcanvas-visible');
    })

    // SHOP DROPDOWN
    $('#offcanvasShop').on('show.bs.offcanvas', () => {
      $('body').addClass('offcanvas-visible');
    })
    $('#offcanvasShop').on('hide.bs.offcanvas', () => {
      $('body').removeClass('offcanvas-visible');
    })

    // SUSTAINABILITY DROPDOWN
    $('#offcanvasSustainability').on('show.bs.offcanvas', () => {
      $('body').addClass('offcanvas-visible');
    })
    $('#offcanvasSustainability').on('hide.bs.offcanvas', () => {
      $('body').removeClass('offcanvas-visible');
    })

    // SEARCH PANEL 
    $('#offcanvasSearch').on('show.bs.offcanvas', () => {
      $('body').addClass('offcanvas-visible');
    })
    $('#offcanvasSearch').on('hide.bs.offcanvas', () => {
      $('body').removeClass('offcanvas-visible');
    })
  */

/* LOGIN PANEL */
$('#offcanvasLogin').on('show.bs.offcanvas', () => {
   $('body').addClass('offcanvas-account-visible');
})

$('#offcanvasLogin').on('hide.bs.offcanvas', () => {
   $('body').removeClass('offcanvas-account-visible');
})

/* REGISTER PANEL */
$('#offcanvasRegister').on('show.bs.offcanvas', () => {
   $('body').addClass('offcanvas-account-visible');
})

$('#offcanvasRegister').on('hide.bs.offcanvas', () => {
   $('body').removeClass('offcanvas-account-visible');
})

/* BAG */
$('#offcanvasBag').on('show.bs.offcanvas', () => {
   $('body').addClass('offcanvas-account-visible');
   $('.product-item__content').removeClass('variable-show');
})

$('#offcanvasBag').on('hide.bs.offcanvas', () => {
   $('body').removeClass('offcanvas-account-visible');
})

/* SIZE GUIDE */
        $('#offcanvasSizeGuide').on('show.bs.offcanvas', () => {
           $('body').addClass('offcanvas-sizeguide-visible');
        })
        
        $('#offcanvasSizeGuide').on('hide.bs.offcanvas', () => {
           $('body').removeClass('offcanvas-sizeguide-visible');
        })

/* FILTERS */
$('#offcanvasFilters').on('show.bs.offcanvas', () => {
   $('body').addClass('offcanvas-filters-visible');
})

$('#offcanvasFilters').on('hide.bs.offcanvas', () => {
   $('body').removeClass('offcanvas-filters-visible');
})




$('#offcanvasSearch').on('shown.bs.offcanvas', () => {
   $('.search-field').trigger('focus');
})




function scrollToVariant() {
  const variantSelector = document.querySelector('.shp-variant_selector'); // Adjust if necessary
  if (variantSelector) {
    variantSelector.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}